import * as React from 'react';
import { UnstyledButton, UnstyledButtonProps, Group, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
    control: {
        borderRadius: 0,
        fontWeight: 500,
        display: 'block',
        width: '100%',
        padding: `${theme.spacing.xs} ${theme.spacing.md}`,
        color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,
        fontSize: theme.fontSizes.sm,

        '&:hover': {
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
            color: theme.colorScheme === 'dark' ? theme.white : theme.black
        }
    }
}));

interface NavLinkItemWrapperProps extends UnstyledButtonProps {
    isWrapped?: boolean;
    children: React.ReactNode;
    onClick?: () => void;
}

export const NavLinkItemWrapper: React.FC<NavLinkItemWrapperProps> = ({ isWrapped, children, ...props }) => {
    const { classes } = useStyles();

    return isWrapped ? (
        <UnstyledButton className={classes.control} {...props}>
            <Group position="apart" spacing={0}>
                {children}
            </Group>
        </UnstyledButton>
    ) : (
        <>{children}</>
    );
};
